import { designTokens } from "@itandi/itandi-bb-ui";
import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { Spinner } from "@itandi/itandi-bb-ui/Spinner";
import { useState } from "react";
import { BackToEditConfirmModal } from "~/components/specifics/deals/[id]/estimations/ocr_requests/[requestId]/BackToEditConfirmModal";

type Props = {
	backToEditPath: string;
};

export function ProcessingState({ backToEditPath }: Props) {
	const [isLeaveConfirmModalOpen, setIsLeaveConfirmModalOpen] = useState(false);

	return (
		<Grid
			gap={designTokens["spacing/l"]}
			justifyItems="center"
			maxWidth="480px"
			mt={designTokens["spacing/6xl"]}
			mx="auto"
		>
			<Grid gap={designTokens["spacing/s"]} justifyItems="center">
				<Spinner size="l" />
				<Grid gap={designTokens["spacing/xs"]} justifyItems="center">
					<Label size="l" weight="bold">
						見積書をAIで読み取っています
					</Label>
					<Paragraph textAlign="center">
						AIがPDFを解析し、施工項目や金額を抽出しています。
						<br />
						通常30秒程度で完了します。処理状況により、最大3分程度かかります。
					</Paragraph>
				</Grid>
			</Grid>
			<Buttonv2
				onClick={() => {
					setIsLeaveConfirmModalOpen(true);
				}}
				variant="secondary"
			>
				見積作成画面へもどる
			</Buttonv2>
			<BackToEditConfirmModal
				alertMessage="今回の読み取り結果にもどることはできません。"
				backToEditPath={backToEditPath}
				isOpen={isLeaveConfirmModalOpen}
				onClose={() => {
					setIsLeaveConfirmModalOpen(false);
				}}
			/>
		</Grid>
	);
}
